import React, { useState } from 'react';
import { IoPersonOutline } from 'react-icons/io5';
import { formatTime, setAgencyInfluencerProfile } from '../../utils';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AGENCY_INFLUENCER_STORAGE_KEY, ROLE_AGENCY, ROLE_INFLUENCER } from '../../constants';
import { set_chat_to_load } from '../../redux/slices/chatsSlice';
import { set_global_notifications } from '../../redux/slices/globalNotificationsSlice';
import useApi from '../../hooks/useApi';
import { set_active_profile } from '../../redux/slices/influencerProfileSlice';
import { FormattedMessage } from 'react-intl';

const Card = ({ payload, type }) => {
    const agency_as_influencer = useSelector(state => state.influencer_profile.active);
    const global_notifications = useSelector(state => state.global_notifications);
    const user = useSelector(state => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { Axios } = useApi();
    const [loading, setLoading] = useState(false);

    const handleNavigate = async () => {
            console.log("payload", payload);
            setLoading(true);
            
            try {
                // Common notification update logic
                const updateNotifications = () => {
                    dispatch(set_global_notifications({
                        sidebar: false,
                        sidebar_api_data: global_notifications.sidebar_api_data.map(item =>
                            item.id === payload?.id ? { ...item, is_read: true } : item
                        ),
                        ...(payload?.is_read === false && {
                            unread_count: global_notifications.unread_count - 1
                        })
                    }));
                };
        
                if (!payload?.influencer_id) {
                    // Case 1: No influencer_id
                    dispatch(set_active_profile(null));
                    localStorage.removeItem(AGENCY_INFLUENCER_STORAGE_KEY);
                    navigate(`/campaign/${payload?.campaign_id}/chats`);
                    updateNotifications();
                    dispatch(set_chat_to_load(payload?.session_id));
                    return;
                }
        
                // Case 2: With influencer_id
                if (user.role === ROLE_INFLUENCER.value || 
                    (agency_as_influencer && agency_as_influencer.id === payload?.influencer_id)) {
                    // Influencer or agency acting as influencer
                    updateNotifications();
                    navigate(`/chats/${payload?.session_id}`);
                    return;
                }
        
                // Agency case - need to fetch influencer profile
                const result = await Axios.get(`api/influencer/${payload?.influencer_id}`);
                dispatch(set_active_profile(result.data.payload));
                setAgencyInfluencerProfile(result.data.payload);
                updateNotifications();
                let timer = setTimeout(() => {
                   navigate(`/chats/${payload?.session_id}`);
               }, 500);
        
            } catch (error) {
                console.error("Navigation error:", error);
                // Consider adding error handling/feedback to user here
            } finally {
                setLoading(false);
            }
        };

    return (
        <div
            onClick={handleNavigate}
            className="group cursor-pointer transition-colors duration-150 hover:bg-primary/5"
        >
            <div className="px-6 py-4 flex items-start gap-4">
                <div className="relative flex-shrink-0">
                    {payload?.sender_picture ? (
                        <img
                            src={payload?.sender_picture}
                            alt={`${payload?.sender_name} ${payload.sender_sur_name}`}
                            className="w-12 h-12 min-w-12 min-h-12 rounded-full object-cover border-2 border-white shadow-md group-hover:border-primary/30 transition-colors"
                        />
                    ) : (
                        <div className="w-12 h-12 min-w-12 min-h-12  rounded-full bg-gray-100 flex items-center justify-center shadow-md group-hover:bg-primary/10 group-hover:text-primary transition-colors">
                            <IoPersonOutline className='text-xl text-gray-500 group-hover:text-primary' />
                        </div>
                    )}
                     {!payload?.is_read && (
                    <div className="absolute -top-1 -right-1 bg-primary text-white rounded-full w-3 h-3 flex items-center justify-center text-[9px] ">                                    </div>
                )}
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start mb-1">
                        <div>
                            {user?.role === ROLE_AGENCY.value && payload?.influencer_id ?
                                <h3 className="font-semibold break-words !line-clamp-3 text-gray-900 text-[13px]">
                                    <FormattedMessage id="got_a_message_for_influencer" defaultMessage={"Got a message for influencer:"} /> {payload.influencer_first_name} {payload.influencer_last_name}
                                </h3>
                                :
                                <h3 className="font-semibold break-all !line-clamp-2 text-gray-900 text-[13px]">
                                    {payload.sender_name} {payload.sender_sur_name}
                                </h3>
                            }
                            <p
                                // onClick={(e) => { e.stopPropagation(); navigate(`/campaign/${payload?.campaign_id}`) }}
                                className="text-xs text-gray-500 inline-flex items-center"
                            >
                                {payload.campaign_name}
                            </p>
                        </div>
                        <span className="text-xs text-gray-500 flex-shrink-0 ml-2">
                            {formatTime(payload?.created_on)}
                        </span>
                    </div>

                    <p className="text-sm text-gray-600 mt-1 group-hover:text-gray-800 transition-colors">
                        {payload?.message.length > 150
                            ? `${payload.message.substring(0, 150)}...`
                            : payload?.message}
                    </p>
                </div>

                {/* {!payload.is_read && (
                    <div className="ml-2 flex-shrink-0 flex items-center">
                        <span className="w-2.5 h-2.5 rounded-full bg-primary animate-pulse"></span>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default Card;